import Vue from 'vue'
import {postFormRequest, postJsonRequest, putFormRequest, putJsonRequest, deleteRequest, getRequest} from './utils/api'
import cookieHelp from './utils/jsCookies.js'
import Session from './utils/Session.js'

Vue.prototype.zhwl = {
  getRequest, // get请求
  postFormRequest, // post 请求content-type为form
  postJsonRequest, // post 请求  content-type为json
  putJsonRequest, // 更新请求-------content-type为json
  deleteRequest, // 删除的请求
  putFormRequest, // 更新的请求-----content-type为form
  cookieHelp,
  _getToken: Session.getToken,
  _setToken: Session.setToken,
  _removeToken: Session.clearToken
}



// WEBPACK FOOTER //
// ./src/initprototype.js